import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import {  FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ValidationService } from "../service/validation.service";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { HeaderComponent } from "./incs/header.component";

import { AccountAddStep2Component } from "./incs/account-add-step2.component";
import { AccountAddStep3Component } from "./incs/account-add-step3.component";
import { Account } from "../entity/Account";
import { Pair } from "../obj/Pair";
import { AccountConsumption } from "../obj/AccountConsumption";
import { ExistingContract } from "../entity/ExistingContract";
import { PreRegisterData } from "../obj/PreRegisterData";

@Component({
    selector: "kilowant-pre-register",
    templateUrl: "../../html/main-pre-register.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, FormsModule, ReactiveFormsModule, AccountAddStep2Component, AccountAddStep3Component]
})
export class PreRegisterComponent extends AbstractComponent {

    userData: string;
    account: Account;
    step: number;
    fileToUpload: File|null = null;
    consumption: AccountConsumption[] = [];
    deleteTaxExemptCertificateDocument: boolean = false;
    existingContractId: number | null = null;
    existingContract: ExistingContract|null = null;

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        public authService: AuthService,
        public validationService: ValidationService
    ) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    pageStart(): void {
        var templateAccountData = <PreRegisterData>this.generalService.getFromSession("preRegisterData");
        if (templateAccountData == null) {
            this.gotoHome();
            return;
        }
        this.userData = templateAccountData.user;
        var templateAccount = templateAccountData.account;
        this.consumption = templateAccountData.consumption;
        this.account = new Account();
        this.account.user = templateAccount.user;
        this.account.fuelType = templateAccount.fuelType;
        this.account.utility = templateAccount.utility;
        this.account.loadZone = templateAccount.loadZone;
        this.account.rateClass = templateAccount.rateClass;
        this.account.company = templateAccount.company;
        this.account.serviceName = templateAccount.serviceName;
        this.account.addressLine1 = templateAccount.addressLine1;
        this.account.addressLine2 = templateAccount.addressLine2;
        this.account.state = templateAccount.state;
        this.account.city = templateAccount.city;
        this.account.zip = templateAccount.zip;
        this.account.accountNumber = templateAccount.accountNumber;
        this.account.keyName = templateAccount.keyName;
        this.account.billImages = [];
        if (templateAccount.billImages != null && templateAccount.billImages.length > 0) {
            for (let i = 0; i < templateAccount.billImages.length; i++) {
                this.account.billImages.push(templateAccount.billImages[i]);
            }
        }        
        this.account.company = templateAccount.company;
        this.step = 2;
        this.refreshView();
    }

    gotoAccountDetails(): void {
        this.step = 2;
        this.refreshView();
    }

    gotoHome(): void {
        this.goto("/");
    }
    finishStep2(next: boolean): void {
        if (!next) {
            this.gotoHome();
            return;
        }
        this.step = 3;
        this.refreshView();
    }
    setTaxtCertificate(certificateFile: File | null) {
        this.fileToUpload = certificateFile;
    }
    setDeleteTaxExemptCertificateChanged(deleteTaxExemptCertificateDocument: boolean): void {
        this.deleteTaxExemptCertificateDocument = deleteTaxExemptCertificateDocument;
    }
    setExistingContractId(existingContractId: number | null): void {
        this.existingContractId = existingContractId;
    }
    setExistingContract(existingContract: ExistingContract | null): void {
        this.existingContract = existingContract;
    }
    finishStep3(next: boolean): void {
        if (!next) {
            this.gotoHome();
        }
        this.generalService.parseBillAndRegisterContinue(this.userData, this.account, this.existingContract, this.consumption, this.fileToUpload).subscribe({
            next: (response: Pair) => {
                this.goto("/user/home");
            },
            error: (err: any) => {
                this.setErrorText(err.error);
                return;
            }
        });
    }
}
